import ssoAjax from "../tools/sso.ajax";
import ssoTool from "../tools/sso.tool";

export function init() {
    const emailVerifyForm = $('#email_verify_form');

    ssoTool.showLoading();

    ssoAjax.submit(emailVerifyForm,
        function() {
            $('.verify-succeed').removeClass('d-none');
            ssoTool.hideLoading();
        },
        function(response) {
            let errorMessage = response.responseJSON?.message || 'something wrong';
            let displayMessage = window.language?.[errorMessage] || errorMessage;

            $('.verify-failed-message').html(displayMessage);
            $('.verify-failed').removeClass('d-none');
            ssoTool.hideLoading();
        });
}
